import { render, staticRenderFns } from "./ReportsSM.vue?vue&type=template&id=0ccc47f0&"
import script from "./ReportsSM.vue?vue&type=script&lang=js&"
export * from "./ReportsSM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports